module.exports = __webpack_public_path__ + "media/newstyle/images/icon-arrow-down-purple-green-ffd591892a126244c339621dfc137bea.svg";